module.exports = {
          srcSet: __webpack_public_path__ + "c3836566f65d7b34241e5bfb74434933-60.png"+" 60w",
          images:[ {path: __webpack_public_path__ + "c3836566f65d7b34241e5bfb74434933-60.png",width: 60,height: 3}],
          src: __webpack_public_path__ + "c3836566f65d7b34241e5bfb74434933-60.png",
          toString:function(){return __webpack_public_path__ + "c3836566f65d7b34241e5bfb74434933-60.png"},
          
          width: 60,
          height: 3
        }